<template>
    <layout>
        <template v-slot:bradcrumbs>
            <ui-breadcrumbs design="full">
                <template v-slot:left>
                </template>
                <template v-slot:right>
                    <ui-button type="submit" design="sm primary">Botão 1</ui-button>
                    <ui-button type="submit" design="sm success">Botão 2</ui-button>
                </template>
            </ui-breadcrumbs>
        </template>
        <template v-slot:content>
            
            <ui-card-toggle class="mb-20">
                <template v-slot:title>Teste</template>
                <template v-slot:content>
                    <grid-container>
                        <grid-row xs-cols="2" sm-cols="3">
                            <grid-col><div class="box">1</div></grid-col>
                            <grid-col><div class="box">2</div></grid-col>
                            <grid-col><div class="box">3</div></grid-col>
                            <grid-col><div class="box">4</div></grid-col>
                            <grid-col><div class="box">5</div></grid-col>
                            <grid-col><div class="box">6</div></grid-col>
                            <grid-col><div class="box">7</div></grid-col>
                            <grid-col><div class="box">8</div></grid-col>
                            <grid-col><div class="box">9</div></grid-col>
                            <grid-col><div class="box">10</div></grid-col>
                            <grid-col><div class="box">11</div></grid-col>
                            <grid-col><div class="box">12</div></grid-col>
                        </grid-row>
                    </grid-container>
                    <br>
                    <ui-button type="submit" design="md success" @click="openModal('modal-2')">Modal 1</ui-button>
                </template>
            </ui-card-toggle>
            
            <ui-card-accordion-body>
                <ui-card-accordion-item>
                    <template v-slot:title>Card 1</template>
                    <template v-slot:content>
                        
                        <grid-container>
                            <grid-row>
                                <grid-col><div class="box">1</div></grid-col>
                                <grid-col><div class="box">2</div></grid-col>
                                <grid-col><div class="box">3</div></grid-col>
                                <grid-col><div class="box">4</div></grid-col>
                                <grid-col><div class="box">5</div></grid-col>
                                <grid-col><div class="box">6</div></grid-col>
                                <grid-col><div class="box">7</div></grid-col>
                                <grid-col><div class="box">8</div></grid-col>
                                <grid-col><div class="box">9</div></grid-col>
                                <grid-col><div class="box">10</div></grid-col>
                                <grid-col><div class="box">11</div></grid-col>
                                <grid-col><div class="box">12</div></grid-col>
                            </grid-row>
                        </grid-container>


                    </template>
                </ui-card-accordion-item>

                <ui-card-accordion-item>
                    <template v-slot:title>Card 1</template>
                    <template v-slot:content>
                        <p>Renderiza o elemento e componente somente uma vez. Em re-renderizações subsequentes, o elemento/componente e todos seus filhos serão tratados como conteúdo estático e pulados. Isso pode ser usado para otimizar o desempenho da atualização.</p>
                    </template>
                </ui-card-accordion-item>
                
            </ui-card-accordion-body>


            <ui-card-tab-main active="content-1">
                <ui-card-tab-button content="content-1">Card Aba 1</ui-card-tab-button>
                <ui-card-tab-button content="content-2">Card Aba 2</ui-card-tab-button>
                <ui-card-tab-button content="content-3">Card Aba 3</ui-card-tab-button>

                <ui-card-tab-content id="content-1">
                    <grid-container>
                        <grid-row cols="6" xs-cols="2" sm-cols="3">
                            <grid-col><div class="box">1</div></grid-col>
                            <grid-col><div class="box">2</div></grid-col>
                            <grid-col><div class="box">3</div></grid-col>
                            <grid-col><div class="box">4</div></grid-col>
                            <grid-col><div class="box">5</div></grid-col>
                            <grid-col><div class="box">6</div></grid-col>
                            <grid-col><div class="box">7</div></grid-col>
                            <grid-col><div class="box">8</div></grid-col>
                            <grid-col><div class="box">9</div></grid-col>
                            <grid-col><div class="box">10</div></grid-col>
                            <grid-col><div class="box">11</div></grid-col>
                            <grid-col><div class="box">12</div></grid-col>
                        </grid-row>
                    </grid-container>
                </ui-card-tab-content>
                <ui-card-tab-content id="content-2">
                    <p>Renderiza o elemento e componente somente uma vez. Em re-renderizações subsequentes, o elemento/componente e todos seus filhos serão tratados como conteúdo estático e pulados. Isso pode ser usado para otimizar o desempenho da atualização.</p>
                </ui-card-tab-content>
                <ui-card-tab-content id="content-3">
                    <p>Renderiza o elemento e componente somente uma vez. Em re-renderizações subsequentes, o elemento/componente e todos seus filhos serão tratados como conteúdo estático e pulados. Isso pode ser usado para otimizar o desempenho da atualização.</p>
                </ui-card-tab-content>

            </ui-card-tab-main>


            <ui-modal id="modal-2" title="Modal - 2" :design="design + ' xs'">
                <p>Modals are streamlined, but flexible dialog prompts powered by JavaScript and CSS. They support a number of use cases from user notification to completely custom content and feature a handful of helpful sub-components, sizes, variants, accessibility, and more.</p>
                <select v-model="design">
                    <option value="">Centro</option>
                    <option value="align-top">Centro Topo</option>
                    <option value="align-bottom">Centro Bottom</option>
                    <option value="align-left">Esquerdo Centro</option>
                    <option value="align-left align-top">Esquerdo Topo</option>
                    <option value="align-left align-bottom">Esquerdo Bottom</option>
                    <option value="align-right">Direito Centro</option>
                    <option value="align-right align-top">Direito Topo</option>
                    <option value="align-bottom align-right">Direito Bottom</option>
                </select>
                <template v-slot:footer>
                    <ui-button type="submit" design="sm primary" @click="closeModal('modal-2')">Confirmar</ui-button>
                </template>
            </ui-modal>

        </template>
    </layout>
</template>
<script>
    import layout from '@/templates/page-panel'

    import { uiButton }                         from '@/components/ui/buttons'
    import { uiBreadcrumbs }                    from '@/components/ui'
    import { gridContainer, gridRow, gridCol }  from '@/components/ui/grid'
    import { uiModal }                          from '@/components/ui/modal'

    

    import {
        uiCardToggle,
        uiCardAccordionBody,
        uiCardAccordionItem,
        uiCardTabMain,
        uiCardTabButton,
        uiCardTabContent
    } from '@/components/ui/cards'
    

    export default {
        components: {
            layout,
            uiCardToggle,
            uiCardAccordionBody,
            uiCardAccordionItem,
            uiCardTabMain,
            uiCardTabButton,
            uiCardTabContent,
            gridContainer,
            gridRow,
            gridCol,
            uiBreadcrumbs,
            uiButton,
            uiModal
        },
        mixins: [],
        data() {
            return {
                show: false,
                design: 'align-bottom',
            }
        },
        methods: {
            openModal(id){
                this.$root.$emit('modal-open', id);
            },
            closeModal(id){
                this.$root.$emit('modal-close', id);
            },
        },
        created(){
            
        }
    };
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>


